module.exports = __webpack_public_path__ + "static/scale-model-of-meissner-inc-in-ann-arbor-michigan-4aadc272d86231ed07cc19ba8046b272.png";